module.exports = __webpack_public_path__ + "img/rojo.415f5174.svg";